import { render, staticRenderFns } from "./McuResultAttachments.vue?vue&type=template&id=389ea0b0&scoped=true"
import script from "./McuResultAttachments.vue?vue&type=script&lang=js"
export * from "./McuResultAttachments.vue?vue&type=script&lang=js"
import style0 from "./McuResultAttachments.vue?vue&type=style&index=0&id=389ea0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ea0b0",
  null
  
)

export default component.exports